// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--3bqB_cf"};